var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollections = function SvgCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections_svg__a)",
    fillRule: "evenodd",
    d: "M2.25 4.875C2.25 3.839 3.09 3 4.125 3h11.25c1.035 0 1.875.84 1.875 1.875V6.75h2.625c1.035 0 1.875.84 1.875 1.875V18a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V4.875ZM16.151 19.5H5.25a1.5 1.5 0 0 1-1.5-1.5V4.875c0-.207.168-.375.375-.375h11.25c.207 0 .375.168.375.375V18c0 .546.146 1.059.401 1.5Zm2.599 0a1.5 1.5 0 0 0 1.5-1.5V8.625a.375.375 0 0 0-.375-.375H17.25V18a1.5 1.5 0 0 0 1.5 1.5Zm-13.5-12A.75.75 0 0 1 6 6.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75v-3Zm1.5.75v1.5h1.5v-1.5h-1.5Zm4.5-.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Zm-6 3a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections_svg__a",
    x1: 2.25,
    x2: 4.633,
    y1: 3,
    y2: 23.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })))));
};
export default SvgCollections;